var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListV3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 2.16992V16.1699H2.50024V2.16992H16.5002ZM17.6002 0.169922H1.40024C0.900244 0.169922 0.500244 0.569922 0.500244 1.06992V17.2699C0.500244 17.6699 0.900244 18.1699 1.40024 18.1699H17.6002C18.0002 18.1699 18.5002 17.6699 18.5002 17.2699V1.06992C18.5002 0.569922 18.0002 0.169922 17.6002 0.169922ZM8.50024 4.16992H14.5002V6.16992H8.50024V4.16992ZM8.50024 8.16992H14.5002V10.1699H8.50024V8.16992ZM8.50024 12.1699H14.5002V14.1699H8.50024V12.1699ZM4.50024 4.16992H6.50024V6.16992H4.50024V4.16992ZM4.50024 8.16992H6.50024V10.1699H4.50024V8.16992ZM4.50024 12.1699H6.50024V14.1699H4.50024V12.1699Z",
    fill: "#BBBBBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListV3);
export default __webpack_public_path__ + "static/media/ListV3.defd1d371a79ec3026d7f6172cb16a3c.svg";
export { ForwardRef as ReactComponent };